import { render, staticRenderFns } from "./BasicModal.vue?vue&type=template&id=6bf2133b&scoped=true&"
import script from "./BasicModal.vue?vue&type=script&lang=ts&"
export * from "./BasicModal.vue?vue&type=script&lang=ts&"
import style0 from "./BasicModal.vue?vue&type=style&index=0&id=6bf2133b&lang=scss&scoped=true&"
import style1 from "./BasicModal.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf2133b",
  null
  
)

export default component.exports